/**
 * 작성 화면을 떠날 때 "저장하지 않은 데이터는 삭제됩니다" 확인을 건너뛸지 정한다.
 *
 * 세션이 끝나 로그인 화면으로 강제로 보내는 경우에는 저장할 방법이 없으므로 묻지 않는다.
 * (여기서 취소하면 로그아웃된 채 작성 화면에 남게 된다)
 */
let bypassToLogin = false;

/** 다음 번 로그인 화면 이동 한 번은 확인 없이 보낸다. */
export function bypassLeaveGuardToLogin() {
  bypassToLogin = true;
}

/** 이번 이동이 확인 없이 보내야 하는 이동인지 확인하고, 표시를 지운다. */
export function consumeLeaveGuardBypass(to) {
  if (!bypassToLogin || !to || to.path !== "/login") return false;
  bypassToLogin = false;
  return true;
}
